import { CheckedState } from "@radix-ui/react-checkbox";
import React, { AriaAttributes } from "react";
import { Control, FieldValues, Path, RegisterOptions, useController } from "react-hook-form";
import CheckboxCard from "./CheckboxCard";

interface Props<$FieldValues extends FieldValues> extends AriaAttributes {
  options: string[];
  name: Path<$FieldValues>;
  rules?: RegisterOptions;
  control: Control<$FieldValues>;
  children?: React.ReactNode;
}

const CheckboxCards = <$FieldValues extends FieldValues>(
  props: Props<$FieldValues>,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { field } = useController({
    name: props.name,
    control: props.control,
    rules: props.rules,
  });

  const [value, setValue] = React.useState<string[]>((field.value as any) ?? []);

  const handleChange = (state: CheckedState, option: string) => {
    const newValue = [
      ...(state === true
        ? new Set([...value, option])
        : new Set(value.filter((v) => v !== option))),
    ];

    field.onChange(newValue);

    setValue(newValue);
  };

  return (
    <>
      {props.options.map((option) => (
        <CheckboxCard
          key={option}
          aria-invalid={props["aria-invalid"]}
          value={option}
          checked={value.includes(option)}
          ref={ref}
          onCheckedChange={(state) => handleChange(state, option)}
        >
          {option}
        </CheckboxCard>
      ))}
    </>
  );
};

export default React.forwardRef(CheckboxCards);
